export default "__VITE_ASSET__DEXBHMbY__"